import React from 'react';
import { CalendarIcon, CompassIcon, LayersIcon, MessageCircleIcon, TicketIcon, UserIcon } from 'lucide-react';
import { AppShell, type NavItem } from './AppShell';
import { useMarketplace } from '../contexts/MarketplaceContext';
import { useLanguage } from '../contexts/LanguageContext';
import type { Role } from '../types/marketplace';
export function RoleShell({
  role
}: {
  role: Role;
}) {
  const {
    visibleInvites,
    offers,
    matches,
    messages,
    events,
    me,
    hasMatch
  } = useMarketplace();
  const {
    t
  } = useLanguage();
  const unread = (ids: string[]) => ids.filter(id => {
    const list = messages[id] ?? [];
    const last = list[list.length - 1];
    return last && last.from !== role && last.from !== 'system';
  }).length;
  let items: NavItem[];
  if (role === 'performer') {
    const mine = matches.filter(m => m.performerId === me.id).map(m => m.id);
    const pendingOffers = offers.filter(o => o.status === 'pending' && mine.includes(o.matchId)).length;
    items = [{
      to: '/p/discover',
      label: t('tab.discover'),
      icon: CompassIcon
    }, {
      to: '/p/gigs',
      label: t('tab.gigs'),
      icon: TicketIcon,
      badge: visibleInvites.length + pendingOffers
    }, {
      to: '/p/messages',
      label: t('tab.messages'),
      icon: MessageCircleIcon,
      badge: unread(mine)
    }, {
      to: '/p/profile',
      label: t('tab.profile'),
      icon: UserIcon
    }];
  } else {
    const myEvents = events.filter(e => e.ownedByMe && e.status === 'live');
    const mine = matches.filter(m => myEvents.some(e => e.id === m.eventId)).map(m => m.id);
    const toReview = myEvents.reduce((n, e) => n + e.applicantIds.filter(id => !hasMatch(e.id, id)).length, 0);
    items = [{
      to: '/o/events',
      label: t('tab.events'),
      icon: CalendarIcon
    }, {
      to: '/o/review',
      label: t('tab.review'),
      icon: LayersIcon,
      badge: toReview
    }, {
      to: '/o/messages',
      label: t('tab.messages'),
      icon: MessageCircleIcon,
      badge: unread(mine)
    }, {
      to: '/o/account',
      label: t('tab.account'),
      icon: UserIcon
    }];
  }
  return <AppShell items={items} data-id="element-685" data-mp="k3tgybaqdytn" />;
}